import memoize from 'fast-memoize'

let testVideo, canPlayHLS

export function httpsify( url = "" ) {
	return url.replace(/http:\/\//, 'https://')
}

const _selectBestVimeoSource = (data, maxSize = 1280) => {
	
	if (!data) { return false }
	let { files } = data

	if (!testVideo && window.navigator.userAgent.match(/ios|android/i)) {

		testVideo = document.createElement('video')
		canPlayHLS = testVideo.canPlayType('application/vnd.apple.mpegURL')
		canPlayHLS = !!canPlayHLS
	}

	if (canPlayHLS) {
		return files.find(t => t.quality === 'hls')
	}

	if (false) {
		console.group(maxSize);
	}
	maxSize += maxSize < 1280 ? 300 : 0
	let bestOption = null, bestOptionLength = null
	files = files
		.filter(fileData => !!fileData.width)
		.sort((a,b) => a.size > b.size ? 1 : -1)
	files.forEach(fileData => {
		var length = fileData.width //Math.max(fileData.width, fileData.height)
		if (bestOption == null || (length <= maxSize && length > bestOptionLength)) {
			bestOption = fileData
			bestOptionLength = length
		}
	})

	if (false) {
		console.log(files.map(fileData => fileData.width));
		console.log(bestOptionLength);
		console.groupEnd()
	}

	return bestOption
}


export const _selectBestVimeoPoster = (data, size = 1280) => {
	if (!data) { return false }
	let maxSize = Math.max(size, 1280)
	let bestOption = null, bestOptionLength = null
	var files = data.pictures.sizes
	files.sort((a,b) => a.width > b.width).forEach(fileData => {
		var length = Math.max(fileData.width, fileData.height)
		if (bestOption == null || (bestOptionLength < length && length <= maxSize)) {
			bestOption = fileData
			bestOptionLength = length
		}
	})
	bestOption.link = bestOption.link && httpsify(bestOption.link.replace(/(_\d{1,})x(.*)(\.[a-z]{3,4})\/??(.+)$/,'$1$3'))
	
	return bestOption
}

export const selectBestVimeoPoster = memoize(_selectBestVimeoPoster)
export const selectBestVimeoSource = memoize(_selectBestVimeoSource)



// WEBPACK FOOTER //
// ./src/lib/vimeo_data_util.js